import { ONBOARDING_FLOW } from '@frontend/product-onboarding';
import { pendo } from '@frontend/tracking';

const BASE_ONBOARDING_ID = ONBOARDING_FLOW.CI_BASE.id;

export const CI_BASE_ONBOARDING_EVENTS = {
  bannerSeen: `${BASE_ONBOARDING_ID}:onboarding-banner-seen`,
  bannerAutoDismissed: `${BASE_ONBOARDING_ID}:onboarding-banner-auto-dismissed`,

  checklistAutoOpened: `${BASE_ONBOARDING_ID}:onboarding-checklist-auto-opened`,
  checklistNudgeOpened: `${BASE_ONBOARDING_ID}:onboarding-checklist-nudge-opened`,
  checklistSeen: `${BASE_ONBOARDING_ID}:onboarding-checklist-seen`,
  checklistCompleted: `${BASE_ONBOARDING_ID}:onboarding-checklist-completed`,
  checklistExpiredIncomplete: `${BASE_ONBOARDING_ID}:onboarding-checklist-expired-incomplete`,
  checklistExpiredComplete: `${BASE_ONBOARDING_ID}:onboarding-checklist-expired-complete`,

  taskCompleted: {
    viewCallInsights: `${BASE_ONBOARDING_ID}:onboarding-view-call-insights-task-completed`,
    viewPatientContext: `${BASE_ONBOARDING_ID}:onboarding-view-patient-context-task-completed`,
    assignUserRoles: `${BASE_ONBOARDING_ID}:onboarding-assign-user-roles-task-completed`,
  },

  hotspotSeen: {
    callsNavigation: `${BASE_ONBOARDING_ID}:onboarding-calls-navigation-hotspot-seen`,
    callInsightButton: `${BASE_ONBOARDING_ID}:onboarding-call-insight-button-hotspot-seen`,
    transcriptTab: `${BASE_ONBOARDING_ID}:onboarding-transcript-tab-hotspot-seen`,
    patientAvatar: `${BASE_ONBOARDING_ID}:onboarding-patient-avatar-hotspot-seen`,
    lastCallCard: `${BASE_ONBOARDING_ID}:onboarding-last-call-card-hotspot-seen`,
    viewHistoryButton: `${BASE_ONBOARDING_ID}:onboarding-view-history-button-hotspot-seen`,
    settingsIcon: `${BASE_ONBOARDING_ID}:onboarding-settings-icon-hotspot-seen`,
    userManagementNav: `${BASE_ONBOARDING_ID}:onboarding-user-management-nav-hotspot-seen`,
  },

  tooltipSeen: {
    transcriptTab: `${BASE_ONBOARDING_ID}:onboarding-transcript-tab-tooltip-seen`,
    lastCallCard: `${BASE_ONBOARDING_ID}:onboarding-last-call-card-tooltip-seen`,
    patientHistoryCall: `${BASE_ONBOARDING_ID}:onboarding-patient-history-call-tooltip-seen`,
    userTableAction: `${BASE_ONBOARDING_ID}:onboarding-user-table-action-tooltip-seen`,
  },
} as const;

export const CI_BASE_ONBOARDING_TRACKING_IDS = {
  bannerShowMeAroundClick: `${BASE_ONBOARDING_ID}:onboarding-banner-show-me-around-click`,
  bannerDismissClick: `${BASE_ONBOARDING_ID}:onboarding-banner-dismiss-click`,

  getStartedNavClick: `${BASE_ONBOARDING_ID}:onboarding-get-started-nav-click`,

  taskNavigationClick: {
    viewCallInsights: `${BASE_ONBOARDING_ID}:onboarding-view-call-insights-nav-click`,
    viewPatientContext: `${BASE_ONBOARDING_ID}:onboarding-view-patient-context-nav-click`,
    assignUserRoles: `${BASE_ONBOARDING_ID}:onboarding-assign-user-roles-nav-click`,
  },

  hotspotInteraction: {
    callsNavigation: `${BASE_ONBOARDING_ID}:onboarding-calls-navigation-hotspot-click`,
    callInsightButton: `${BASE_ONBOARDING_ID}:onboarding-call-insight-button-hotspot-click`,
    transcriptTab: `${BASE_ONBOARDING_ID}:onboarding-transcript-tab-hotspot-click`,
    patientAvatar: `${BASE_ONBOARDING_ID}:onboarding-patient-avatar-hotspot-click`,
    lastCallCard: `${BASE_ONBOARDING_ID}:onboarding-last-call-card-hotspot-click`,
    viewHistoryButton: `${BASE_ONBOARDING_ID}:onboarding-view-history-button-hotspot-click`,
    settingsIcon: `${BASE_ONBOARDING_ID}:onboarding-settings-icon-hotspot-click`,
    userManagementNav: `${BASE_ONBOARDING_ID}:onboarding-user-management-nav-hotspot-click`,
  },
} as const;

export function trackBaseOnboardingEvent(eventName: string, properties?: pendo.Metadata) {
  pendo.track(eventName, {
    ...properties,
  });
}
